/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import FlaccScore from './flacc-score';
import FlaccScoreDetail from './flacc-score-detail';
import FlaccScoreUpdate from './flacc-score-update';
import FlaccScoreDeleteDialog from './flacc-score-delete-dialog';

const FlaccScoreRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<FlaccScore />} />
    <Route path="new" element={<FlaccScoreUpdate />} />
    <Route path=":id">
      <Route index element={<FlaccScoreDetail />} />
      <Route path="edit" element={<FlaccScoreUpdate />} />
      <Route path="delete" element={<FlaccScoreDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default FlaccScoreRoutes;
